import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import AppContext from "../../../utils/context";
import Markdown from "react-markdown";
import { PieChart } from '@mui/x-charts/PieChart';

export default function View(props) {
  const appContext = useContext(AppContext);
  return (
    props?.format_data?.data && (
      <PieChart series={props?.format_data?.data} />
    )
  );
}
